module.exports = __webpack_public_path__ + "img/icon-video-supp-file.67fb41c0.svg";